<template>
  <div v-show="!(field.hide && field.hide())"  :class="field.classList">

    <md-field :key="name + '_input'"
        :class="[
        { 'md-valid': !$vo[name].$invalid },
        { 'md-error': $vo[name].$invalid },
        { '_uiKitInput': isUiKit },
      ]"
    >
      <label>{{ field.label }}</label>
      <select
          :key="name"
          :name="name"
          v-model="$vo[name].$model"
          :disabled="pageMode == 'view' || pageMode == 'assignee' || field.preventEdit"
          class="md-list-item-button md-list-item-container md-button-clean"
          style="padding: 7px;font-size: 14px; color: #13294d !important;"
      >
        <option v-for="item in field.options" :value="item.id" :key="item.id"
        :disabled="field.preventOptSelect === item.id"
        > {{ item.name }} </option>
      </select>
    </md-field>
  </div>
</template>
<script>
  export default {
    name: "crud-select",
    components: {},
    props: {
      field: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      pageMode: {
        type: String,
        required: true
      },
      form: {
        type: Object,
        required: true
      },
      $vo: {
        type: Object,
        required: true
      },
      isUiKit: {
        type: Boolean,
        default: () => true,
      },
    },
    data() {
      return {}
    },
  };
</script>